import React from "react";
import SidemenuLayout from "../../../../layout/DefaultLayout/Layouts/SidemenuLayout";
import ProductView1 from "../ProductView1";
import { Item } from "../../../../containers/commerce";
import { Col, Row, Container, Div } from "../../../grid";
import {
  Varedata,
  RenderNameHeading,
  RenderButtons,
  RenderPallePricePrPiece,
  RenderProductPageDescription,
  RenderProductPageXtraDescription,
  RenderImages,
  RenderSchemaTag,
  RenderSizeBottlesAndGlass,
  RenderCountPrColli,
  RenderAlcPctBottles,
  RenderBottlePrices,
  RenderOelType,
  RenderProductTypePack,
  RenderDescription,
  RenderProductPageDescriptionLong,
  RenderTooltip,
  RenderDiscount,
  RenderLavLiterpris,
  RenderRelated,
  RenderCampaignRoyal,
  RenderCampaignHerslev,
  RenderCampaignNorrebro,
  RenderFadoelsType,
  RenderFadoelLand,
  RenderFadoelAlcPct,
  RenderFadoelKobling,
  RenderFadoelPrice,
  RenderInStock,
  RenderModularText,
  RenderIndhold,
} from "./components";
import RenderCampaignHeineken from "./components/RenderCampaignHeineken";

export default React.forwardRef((props) => {
  const {
    price,
    beforePrice,
    discount,
    liter,
    name,
    amount,
    actions,
    productPageDescription,
    productPageDescriptionLong,
    productPageXtraDescription,
    serena,
    fadoelsType,
    fadKobling,
    alcoholPercentage,
    alcPctNum,
    imageSingle,
    imagePlural,
    singleWidth,
    pluralWidth,
    notice,
    land,
    heading,
    showModularText,
    related,
    relatedHeadline,
    extraItemRef,
    inStock,
    inStockText,
    menuPicker,
    activeSidemenu,
    countPrColli,
    productTypeFadoel,
    packageNoun,
    productTypePack,
    packImages,
    imageDescription,
    imageMaxHeight,
    description,
    betingerFustager,
    isLeje,
    replaceStkWithPackageNoun,
    simpleAmountDescriptor,
    extendedAmountDescriptor,
    IconBoxes,
    productTypeGlass,
    productTypeReservedel,
    url,
    varenr,
    SizeGlass,
    productTypePalle,
    indhold,
    oelType,
    tooltip,
    showOnlyPluralPrice,
    productPageXtraProduct,
    udsolgtAnlaeg,
    udsolgtKlapbar,
    dobbeltAnlaeg,
    stilladsbar,
    productPageMaxImageHeight,
    dontShowColli,
    showAlcPct,
    royalUnibrew,
    herslevBryghus,
    palleItem,
    countPrPalle,
    lavLiterpris,
    priceSuffix,
    heinekenOffer,
    norrebro,
  } = props;
  return (
    <SidemenuLayout menuPicker={menuPicker} activeSidemenu={activeSidemenu}>
      <Div ref={extraItemRef}>
        <Container mb>
          <Row>
            <Col md={productPageXtraProduct ? 6 : 12} padding="0 15px">
              <Row white={amount === 0} green={amount > 0}>
                <Col xs={productTypePack ? 6 : productPageXtraProduct ? 12 : 5}>
                  <RenderNameHeading
                    className="RenderNameHeading"
                    heading={heading}
                    name={name}
                    countPrColli={countPrColli}
                    liter={liter}
                    productTypePack={productTypePack}
                    description={description}
                    productTypeGlass={productTypeGlass}
                    productTypeReservedel={productTypeReservedel}
                    productTypeFadoel={productTypeFadoel}
                  />
                  <RenderDescription
                    className="RenderDescription"
                    productTypePack={productTypePack}
                    description={description}
                  />
                  <Row>
                    {!productTypeFadoel && !productTypePack && (
                      <React.Fragment>
                        <RenderSizeBottlesAndGlass
                          className="RenderSizeBottlesAndGlass"
                          productTypeReservedel={productTypeReservedel}
                          productTypeGlass={productTypeGlass}
                          SizeGlass={SizeGlass}
                          liter={liter}
                          countPrColli={countPrColli}
                        />
                        {!productTypeReservedel && (
                          <RenderCountPrColli
                            className="RenderCountPrColli"
                            dontShowColli={dontShowColli}
                            countPrColli={countPrColli}
                            productTypePalle={productTypePalle}
                            countPrPalle={countPrPalle}
                            packageNoun={packageNoun}
                          />
                        )}
                        <RenderAlcPctBottles
                          className="RenderAlcPctBottles"
                          alcoholPercentage={alcoholPercentage}
                          productTypeGlass={productTypeGlass}
                          productTypeReservedel={productTypeReservedel}
                          alcPctNum={alcPctNum}
                          showAlcPct={showAlcPct}
                        />
                        <RenderOelType
                          className="RenderOelType"
                          oelType={oelType}
                        />
                        <RenderBottlePrices
                          className="RenderBottlePrices"
                          showOnlyPluralPrice={showOnlyPluralPrice}
                          productPageXtraProduct={productPageXtraProduct}
                          price={price}
                          liter={liter}
                          countPrColli={countPrColli}
                          isLeje={isLeje}
                          packageNoun={packageNoun}
                          productTypePalle={productTypePalle}
                          varenr={varenr}
                          priceSuffix={priceSuffix}
                        />
                        <RenderPallePricePrPiece
                          className="RenderPallePricePrPiece"
                          palleItem={palleItem}
                        />
                        <RenderButtons
                          className="RenderButtons"
                          amount={amount}
                          actions={actions}
                          inStock={inStock}
                          inStockText={inStockText}
                          notice={notice}
                        />
                      </React.Fragment>
                    )}
                    {productTypeFadoel && (
                      <React.Fragment>
                        <RenderFadoelKobling
                          className="RenderFadoelKobling"
                          fadKobling={fadKobling}
                        />
                        <RenderFadoelsType
                          className="RenderFadoelsType"
                          fadoelsType={fadoelsType}
                        />
                        <RenderFadoelLand
                          className="RenderFadoelLand"
                          land={land}
                        />
                        <RenderFadoelAlcPct
                          className="RenderFadoelAlcPct"
                          alcoholPercentage={alcoholPercentage}
                        />
                        <RenderFadoelPrice
                          className="RenderFadoelPrice"
                          price={price}
                          liter={liter}
                          productTypeFadoel={productTypeFadoel}
                        />
                        <RenderInStock
                          className="RenderInStock"
                          inStock={inStock}
                        />
                        <RenderButtons
                          className="RenderButtons"
                          amount={amount}
                          actions={actions}
                          inStock={inStock}
                          inStockText={inStockText}
                          notice={notice}
                        />
                        <RenderModularText
                          className="RenderModularText"
                          showModularText={showModularText}
                          inStock={inStock}
                        />
                        <RenderCampaignRoyal
                          className="RenderCampaignRoyal"
                          royalUnibrew={royalUnibrew}
                        />
                        <RenderCampaignHeineken
                          className="RenderCampaignRoyal"
                          heinekenOffer={heinekenOffer}
                        />
                        <RenderCampaignHerslev
                          className="RenderCampaignHerslev"
                          herslevBryghus={herslevBryghus}
                        />
                        <RenderCampaignNorrebro
                          className="RenderCampaignNorrebro"
                          norrebro={norrebro}
                        />
                      </React.Fragment>
                    )}
                    <RenderProductTypePack
                      className="RenderProductTypePack"
                      description={description}
                      countPrColli={countPrColli}
                      productTypePack={productTypePack}
                      betingerFustager={betingerFustager}
                      dobbeltAnlaeg={dobbeltAnlaeg}
                      stilladsbar={stilladsbar}
                      udsolgtAnlaeg={udsolgtAnlaeg}
                      udsolgtKlapbar={udsolgtKlapbar}
                      IconBoxes={IconBoxes}
                      price={price}
                      isLeje={isLeje}
                      replaceStkWithPackageNoun={replaceStkWithPackageNoun}
                      simpleAmountDescriptor={simpleAmountDescriptor}
                      extendedAmountDescriptor={extendedAmountDescriptor}
                      packageNoun={packageNoun}
                      amount={amount}
                      actions={actions}
                      inStock={inStock}
                      inStockText={inStockText}
                      notice={notice}
                    />
                  </Row>
                  <RenderDiscount
                    className="RenderDiscount"
                    discount={discount}
                    beforePrice={beforePrice}
                  />
                  <RenderTooltip className="RenderTooltip" tooltip={tooltip} />
                  <RenderLavLiterpris
                    className="RenderLavLiterpris"
                    lavLiterpris={lavLiterpris}
                  />
                  <RenderProductPageDescription
                    className="RenderProductPageDescription"
                    productPageDescription={productPageDescription}
                    productPageDescriptionLong={productPageDescriptionLong}
                  />
                </Col>
                <Col
                  xs={productTypePack ? 6 : productPageXtraProduct ? 12 : 7}
                  textCenter={productTypePack}
                  paddingTop="15px"
                >
                  <RenderImages
                    className="RenderImages"
                    imageSingle={imageSingle}
                    imagePlural={imagePlural}
                    singleWidth={singleWidth}
                    pluralWidth={pluralWidth}
                    productTypePack={productTypePack}
                    packImages={packImages}
                    imageDescription={imageDescription}
                    imageMaxHeight={imageMaxHeight}
                    productPageMaxImageHeight={productPageMaxImageHeight}
                    productPageXtraProduct={productPageXtraProduct}
                  />
                </Col>
                <RenderIndhold className="RenderIndhold" indhold={indhold} />
              </Row>
              <RenderProductPageDescriptionLong
                className="RenderProductPageDescriptionLong"
                big
                productPageDescriptionLong={productPageDescriptionLong}
              />
            </Col>
            {productPageXtraProduct && (
              <Col md={productPageXtraProduct ? 6 : 12} padding="0 0 0 15px">
                <Item
                  varenr={productPageXtraProduct}
                  display={ProductView1}
                  productPageXtraProductTrue
                />
              </Col>
            )}
          </Row>
        </Container>
        <RenderProductPageXtraDescription
          serena={serena}
          productPageXtraDescription={productPageXtraDescription}
        />
        <Varedata {...props} productTypePack={productTypePack} />
        <RenderRelated
          related={related}
          headline={relatedHeadline}
          name={name}
        />
      </Div>
      <RenderSchemaTag
        name={name}
        varenr={varenr}
        price={price}
        imageSingle={imageSingle}
        imagePlural={imagePlural}
        url={url}
        inStock={inStock}
      />
    </SidemenuLayout>
  );
});
